import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/layout';
import Seo from '../components/seo';
import { graphql } from 'gatsby';

import HomepageHeroSectionWithLogos from '../components/genericFlexible/homepage/homepageHeroSectionWithLogos';
import HomepagePromoModule from '../components/genericFlexible/homepage/homepagePromoModule';
import HomepageFancyGridModule from '../components/genericFlexible/homepage/homepageFancyGridModule';
import SubpageFancyGridModule from '../components/genericFlexible/homepage/subpageFancyGridModule';
import HomepageIconsDescriptionModule from '../components/genericFlexible/homepage/homepageIconsDescriptionModule';
import HomepageIconsDescriptionModuleSafari from '../components/genericFlexible/homepage/homepageIconsDescriptionModuleSafari';
import HeroSectionWithImageAndVideo from '../components/genericFlexible/heroSectionWithImageAndVideo';
import HeroSectionWithLogos from '../components/genericFlexible/heroSectionWithLogos';
import IconsGridAndFourColumnSection from '../components/genericFlexible/iconsGridAndFourColumnSection';
import FiftyFiftySectionWithDifferentiator from '../components/genericFlexible/fiftyFiftySectionWithDifferentiator';
import FaqAccordionSection from '../components/genericFlexible/faqAccordionSection';
import GenericPromoModule from '../components/genericFlexible/genericPromoModule';
import HeroSectionWithFormAndThumbnail from '../components/genericFlexible/heroSectionWithFormAndThumbnail';
import FreeFormHtml from '../components/genericFlexible/freeFormHtml';
import PlatformScrollingTicker from '../components/genericFlexible/platformScrollingTicker';
import RelatedResources from '../components/genericFlexible/relatedResources';
import ImageGridsExecutiveTeams from '../components/genericFlexible/imageGridsExecutiveTeams';
import FeaturedSectionModule from '../components/genericFlexible/featuredSectionModule';
import CustomerStoryModule from '../components/genericFlexible/customerStoryModule';
import PricingTableModule from '../components/genericFlexible/pricingTableModule';
import ComparisonTableModule from '../components/genericFlexible/comparisonTableModule';
import LottieFileAnimationModule from '../components/genericFlexible/lottieFileAnimationModule';
import MarketoFormSectionModule from '../components/genericFlexible/marketoFormSectionModule';
import QuicksizerCalModule from '../components/genericFlexible/quicksizerCalModule';
import ThankYouPageModule from '../components/genericFlexible/thankYouPageModule';

export const query = graphql`
query FlexibleModularQuery($slug: String!) {
  allWordpressPage(filter: {slug: {eq: $slug}}) {
    edges {
      node {
        title
        slug
        seo {
          opengraphTitle
          opengraphDescription
          metaKeywords
          metaDesc
          opengraphAuthor
          title
          focuskw
          opengraphImage {
            altText
            sourceUrl
          }
          readingTime
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            author {
              node {
                name
              }
            }
          }
        }
        modularFlexibleFields {
          modularFields {
            __typename
            ... on WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents {
              homepageComponentsFlexi {
                __typename
                ... on WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents_HomepageComponentsFlexi_HomepageHeroSectionWithLogos {
                  fieldGroupName
                  homepageHeroSectionWithLogosHeader
                  homepageHeroSectionWithLogosTeaser
                  homepageHeroSectionButtons {
                    button {
                      target
                      title
                      url
                    }
                  }
                  homepageHeroSectionMainImage {
                    altText
                    gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                  }
                  homepageHeroSectionMainImageLink{
                    target
                    title
                    url                    
                  }
                  homepageHeroSectionMainImageVideoModal
                  homepageHeroSectionMainImageVideoModalWistia
                  homepageHeroSectionMainImageVideoModalYoutube
                  homepageHeroSectionLogos {
                    altText
                    sourceUrl
                    caption
                  }
                  maxWidth
                  overrideClass
                }
                ... on WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents_HomepageComponentsFlexi_HomepagePromoModule {
                  fieldGroupName
                  homepagePromoModuleSubHeader
                  homepagePromoModuleMainHeader
                  homepagePromoModuleTeaser
                  homepagePromoModuleButton {
                    target
                    title
                    url
                  }
                  homepagePromoModuleBackgroundImage {
                    altText
                    sourceUrl
                  }
                  homepagePromoModuleMainImage {
                    altText
                    gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                  }
                  maxWidth
                  overrideClass
                }
                ... on WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents_HomepageComponentsFlexi_HomepageFancyGridModule {
                  homepageFancyGridModuleHeader
                  homepageFancyGridModuleGridSections {
                    header
                    teaser
                    image {
                      altText
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                    button {
                      target
                      title
                      url
                    }
                  }
                  maxWidth
                  overrideClass
                }
                ... on WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents_HomepageComponentsFlexi_HomepageIconsDescriptionModule {
                  homepageIconsDescriptionModuleHeader
                  homepageIconsDescriptionModuleRepeaterSections {
                    repeaterSectionsHeader
                    repeaterSectionsTeaser
                    repeaterSectionsIcon {
                      altText
                      sourceUrl
                    }
                  }
                  maxWidth
                  overrideClass
                }
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithImageAndVideo {
              maxWidth
              overrideClass
              backgroundGraphic
              backgroundColor
              textColor
              heroSectionHeader
              heroSectionTeaser
              heroSectionHeaderButtons {
                button {
                  target
                  title
                  url
                }
              }
              heroSectionImage {
                altText
                gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
              }
              heroSectionVideoCheck
              heroSectionVideoId
              heroSectionVideoIdYoutube
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithLogos {
              backgroundColor
              maxWidth
              backgroundGraphic
              textColor
              overrideClass
              heroSectionWithLogosHeader
              heroSectionWithLogosTeaser
              heroSectionButtons {
                button {
                  target
                  title
                  url
                }
              }
              heroSectionMainImage {
                altText
                gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
              }
              heroSectionMainImageLink{
                url
                target
                title
              }
              heroSectionLogos {
                altText
                sourceUrl
                caption
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_IconsGridAndFourColumnSection {
              maxWidth
              overrideClass
              iconsGridHeader
              iconsGridAndFourColumnSectionLayoutSelection
              iconsGridAndFourColumnSectionColumnSelection
              iconsGridSections {
                iconsGridSectionHeader
                iconsGridSectionTeaser
                iconsGridSectionIconMaxWidth
                iconsGridSectionIcon {
                  altText
                  sourceUrl
                }
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_FiftyFiftySectionWithChecklistAndDifferentiatorLayout {
              maxWidth
              overrideClass
              fiftyFiftySectionMainHeader
              fiftyFiftySectionMainTeaser
              fiftyFiftySectionLayoutSelection
              fiftyFiftyRepeaterSections {
                fiftyFiftySectionWithChecklistLayoutOneHeader
                fiftyFiftySectionWithChecklistLayoutOneTeaser
                fiftyFiftySectionWithChecklistLayoutOneButton {
                  target
                  title
                  url
                }
                fiftyFiftySectionWithChecklistLayoutOneBulletPoints {
                  bulletHeader
                  bulletTeaser
                  bulletIcon {
                    altText
                    sourceUrl
                  }
                }
                fiftyFiftySectionWithChecklistLayoutTwoHeader
                fiftyFiftySectionWithChecklistLayoutTwoRepeaterContent {
                  repeaterContentHeader
                  repeaterContentTeaser
                }
                fiftyFiftySectionWithChecklistLayoutTwoButton {
                  target
                  title
                  url
                }
                fiftyFiftySectionWithChecklistLayoutTwoSwitchImage
                fiftyFiftySectionWithChecklistLayoutTwoImage {
                  altText
                  gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                }
                videoOrLottieCheck
                selectVideoType
                wistiaId
                youtubeId
                lottieFileLink
              } 
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_FaqAccordionSection {
              faqAccordionSectionHeader
              maxWidth
              faqAccordionRepeaterSections {
                header
                content
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_GenericPromoModule {
              fieldGroupName
              genericPromoModuleLayoutCheck
              homepagePromoModuleSubHeader
              homepagePromoModuleMainHeader
              homepagePromoModuleTeaser
              homepagePromoModuleButton {
                target
                title
                url
              }
              homepagePromoModuleMainImage {
                altText
                gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                sourceUrl
              }
              genericPromoModuleColumnCheck
              genericPromoModuleTextRepeaterSections {
                subHeader
                header
                teaser
                link {
                  target
                  title
                  url
                }
              }
              maxWidth
              overrideClass
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_GenericFancyGridModule {
              homepageFancyGridModuleHeader
              maxWidth
              overrideClass
              homepageFancyGridModuleGridSections {
                header
                teaser
                button {
                  target
                  title
                  url
                }
                image {
                  altText
                  gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                }
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_GenericIconsDescriptionModule {
              maxWidth
              overrideClass
              homepageIconsDescriptionModuleHeader
              homepageIconsDescriptionModuleRepeaterSections {
                repeaterSectionsHeader
                repeaterSectionsTeaser
                repeaterSectionsIcon {
                  altText
                  sourceUrl
                }
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail {
              backgroundColor
              maxWidth
              textColor
              heroSectionWithFormAndThumbnailContentFields {
                __typename
                ... on WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail_HeroSectionWithFormAndThumbnailContentFields_FlexiHeaderField {
                  categoryHeader  
                  header
                  subHeader
                }
                ... on WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail_HeroSectionWithFormAndThumbnailContentFields_FlexiTeaserField {
                  teaser
                }
                ... on WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail_HeroSectionWithFormAndThumbnailContentFields_FlexiImageOrVideoField {
                  imageOrVideo
                  videoId
                  image {
                    altText
                    gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                  }
                  imageLink {
                    target
                    title
                    url
                  }
                  imageMaxWidth
                }
                ... on WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail_HeroSectionWithFormAndThumbnailContentFields_FlexiBulletPoints {
                  bulletPoints {
                    header
                    teaser
                  }
                }
              }
              heroSectionImageAboveTheForm{
                altText
                gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
              }
              heroSectionWithFormAndThumbnailMarketoVsCustomForm
              heroSectionWithFormAndThumbnailCustomForm
              heroSectionWithFormAndThumbnailMarketoVsCustomFormHeader
              heroSectionWithFormAndThumbnailMarketoVsCustomFormId
              heroSectionWithFormAndThumbnailMarketoVsCustomFormCtaOverride
              heroSectionWithFormAndThumbnailMarketoVsCustomFormThankYouMessage
              heroSectionWithFormAndThumbnailMarketoThankYouPage
              heroSectionWithFormCtaButtonColor
              heroSectionFormAssetType
              heroSectionFormLink {
                target
                title
                url
              }
              heroSectionFormPdf {
                mediaItemUrl
              }
              heroSectionWithFormAndThumbnailAdditionTextUnderTheForm
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_FreeFormHtml {
              backgroundColor
              maxWidth
              overrideClass
              freeFormHtmlHeader
              freeFormHtmlBlock
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_PlatformScrollingTicker {
              backgroundColor
              maxWidth
              platformScrollingTickerRepeaterField {
                text
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_RelatedResources {
              backgroundColor
              maxWidth
              relatedResourcesHeader
              relatedResourcesSelection {
                __typename
                ... on WordpressNews {
                  id
                  slug
                  title
                  slug
                  excerpt
                  nodeType
                  date(formatString: "DD MMM YYYY")
                  featuredImage {
                    node {
                      altText
                      sourceUrl
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                  newsPostTypeContent {
                    resourceInitialCheck
                    resourceInitialCheckLink
                    resourceInitialCheckPdf {
                      mediaItemUrl
                    }
                    newsPostTitle
                    newsPostTeaser
                    newsPostContent
                  }
                  newscategories {
                      nodes {
                        name
                      }
                  }
                }
                ... on WordpressPost {
                  id
                  excerpt
                  featuredImage {
                    node {
                      altText
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                  link
                  slug
                  title
                  categories {
                    nodes {
                      name
                    }
                  }
                }
                ... on WordpressResource {
                  id
                  excerpt
                  featuredImage {
                    node {
                      altText
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                  link
                  slug
                  title
                  genericResourceFilters {
                    nodes {
                      name
                    }
                  }
                  resourcePostTypeContent {
                    resourceInitialCheck
                    resourceInitialCheckLink
                    resourceInitialCheckPdf {
                      mediaItemUrl
                    }
                  }
                }
                ... on WordpressCustomerstory {
                  id
                  excerpt
                  featuredImage {
                    node {
                      altText
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                  link
                  slug
                  title
                  customerStoriesPostTypeContent {
                    customerStoriesPostTypeTitle
                    customerStoriesPostTypeTeaser
                }
                }
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_ImageGridsExecutiveTeams {
              backgroundColor
              maxWidth
              imageGridsExecutiveTeamsHeader
              imageGridsExecutiveTeamsMembersRepeater {
                memberName
                memberTitle
                memberBio
                memberTwitterLink
                memberLinkedinLink
                memberThumb {
                  altText
                  gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                }
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_FeaturedSection {
              backgroundColor
              maxWidth
              featuredSectionMainHeader
              featuredSectionMainTeaser
              featuredSectionLayout
              featuredSectionSubHeader
              featuredSectionHeader
              featuredSectionTeaser
              featuredSectionButton {
                target
                title
                url
              }
              featuredSectionImage {
                altText
                gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_CustomerStoriesCarouselModule {
              backgroundColor
              maxWidth
              customerStoriesCarouselMainHeader
              layoutSelection
              customerStoriesCarouselSections {
                teaser
                customerName
                customerTitle
                customerStoryLink {
                  target
                  title
                  url
                }
                logo {
                  altText
                  sourceUrl
                }
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_PricingSection {
              backgroundColor
              maxWidth
              pricingCategory {
                categoryName
                pricingTableColumns {
                  workloadTitle
                  tierSections {
                    tierTitle
                    tierColumns {
                      continuousBackupAndPointInTimeRestore
                      crossAccountBackupRestore
                      fieldGroupName
                      minimumRetention
                      outOfRegionBackupOrRestore
                      restoreBegins
                      restoreGranularity
                      rpo
                      supportedVersions
                      tierAirgap
                      tierBackupPrice
                      tierBackupType
                      tierInstantAccess
                      tierRestorePrice
                    }
                  }
                }
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_ComparisonTable {
              comparisonTableMainSectionHeader
              comparisonTableLogoOne {
                altText
                sourceUrl
              }
              comparisonTableLogoTwo {
                altText
                sourceUrl
              }
              comparisonTableVs
              comparisonTableSections {
                comparisonTableSectionsLeft {
                  header
                  teaser
                }
                comparisonTableSectionsMiddle {
                  altText
                  sourceUrl
                }
                comparisonTableSectionsMiddleText
                comparisonTableSectionsRight {
                  header
                  teaser
                }
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_LottieFileAnimation {
              lottieFileAnimationRepeater {
                title
                teaser
                link
              }
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_MarketoFormSection {
              marketoFormSectionId
              marketoFormThankYouMessage
              marketoThankYouPage
              heroSectionWithFormCtaButtonColor
              maxWidth
              overrideClass
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_QuicksizerCalculator {
              fieldGroupName
            }
            ... on WordpressPage_Modularflexiblefields_ModularFields_ThankYouComponent {
              backgroundColor
              maxWidth
              thankYouComponentLeftSection {
                thankYouComponentLeftSectionFields {
                  __typename
                  ... on WordpressPage_Modularflexiblefields_ModularFields_ThankYouComponent_ThankYouComponentLeftSection_ThankYouComponentLeftSectionFields_Header {
                    thankYouHeader
                  }
                  ... on WordpressPage_Modularflexiblefields_ModularFields_ThankYouComponent_ThankYouComponentLeftSection_ThankYouComponentLeftSectionFields_Image {
                    thankYouImage {
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                  ... on WordpressPage_Modularflexiblefields_ModularFields_ThankYouComponent_ThankYouComponentLeftSection_ThankYouComponentLeftSectionFields_Content {
                    thankYouContent
                  }
                }
              }
              thankYouComponentRightSection {
                thankYouComponentRightSectionHeader
                thankYouComponentAddResources {
                  __typename
                  ... on WordpressResource {
                    id
                    excerpt
                    featuredImage {
                      node {
                        altText
                        gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                      }
                    }
                    link
                    slug
                    title
                    genericResourceFilters {
                      nodes {
                        name
                      }
                    }
                    resourcePostTypeContent {
                      resourceInitialCheck
                      resourceInitialCheckLink
                      resourceInitialCheckPdf {
                        mediaItemUrl
                      }
                    }
                }
                }
                thankYouComponentAddResourcesManual {
                  subHeader
                  header
                  link {
                    title
                    url
                    target
                  }
                  image {
                    altText
                    gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

const Page = ({ data }) => {
  const graphData = data.allWordpressPage.edges[0].node;

  var isSafari = '';
  if (typeof window !== "undefined") {
    isSafari = window.safari !== undefined;
  }

  const [pwdCheck, setPwdCheck] = useState(false);

  useEffect(() => {
    const passwordFunction = () => {
      const pwdCheck = document.querySelector('#password').value;
      if (pwdCheck === 'Clumio123$') {
        setPwdCheck(true);
      }
      else {
        alert("Incorrect password");
      }
    }

    if (document.getElementById("l-passwordProtector")) {
      document.getElementById("l-passwordProtector").addEventListener('submit', function (e) {
        e.preventDefault();
        passwordFunction();
      });
    }
  }, []);

  return (
    <Layout graphData={graphData}>
      {data.allWordpressPage.edges.map((indItem, index) => (
        <Seo data={indItem.node} lang="EN" key={index} />
      ))}
      {graphData.modularFlexibleFields.modularFields &&
        <div className={`cp-flexible cp-wrapper ${graphData ? graphData.slug : ""}`}>
          <div className="cp-flexible__inner">
            {graphData.modularFlexibleFields.modularFields.map((modularItem, index) => (
              <React.Fragment key={index}>
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents' &&
                  <>
                    {modularItem.homepageComponentsFlexi &&
                      <>
                        {modularItem.homepageComponentsFlexi.map((submodularItem, index) => (
                          <React.Fragment key={index}>
                            {submodularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents_HomepageComponentsFlexi_HomepageHeroSectionWithLogos' &&
                              <HomepageHeroSectionWithLogos data={submodularItem} />
                            }
                            {submodularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents_HomepageComponentsFlexi_HomepagePromoModule' &&
                              <HomepagePromoModule data={submodularItem} />
                            }
                            {submodularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents_HomepageComponentsFlexi_HomepageFancyGridModule' &&
                              <HomepageFancyGridModule data={submodularItem} classOverride="cp-homepageModule" />
                            }
                            {!isSafari ?
                              <>
                                {submodularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents_HomepageComponentsFlexi_HomepageIconsDescriptionModule' &&
                                  <HomepageIconsDescriptionModule data={submodularItem} />
                                }
                              </>
                              :
                              <>
                                {submodularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HomepageComponents_HomepageComponentsFlexi_HomepageIconsDescriptionModule' &&
                                  <HomepageIconsDescriptionModuleSafari data={submodularItem} />
                                }
                              </>
                            }
                          </React.Fragment>
                        ))}
                      </>
                    }
                  </>
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithImageAndVideo' &&
                  <HeroSectionWithImageAndVideo data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithLogos' &&
                  <HeroSectionWithLogos data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_IconsGridAndFourColumnSection' &&
                  <IconsGridAndFourColumnSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FiftyFiftySectionWithChecklistAndDifferentiatorLayout' &&
                  <FiftyFiftySectionWithDifferentiator data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FaqAccordionSection' &&
                  <FaqAccordionSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericPromoModule' &&
                  <GenericPromoModule data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericFancyGridModule' &&
                  <SubpageFancyGridModule data={modularItem} classOverride="cp-internalModule" />
                }
                {!isSafari ?
                  <>
                    {
                      modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericIconsDescriptionModule' &&
                      <HomepageIconsDescriptionModule data={modularItem} />
                    }
                  </>
                  :
                  <>
                    {
                      modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericIconsDescriptionModule' &&
                      <HomepageIconsDescriptionModuleSafari data={modularItem} />
                    }
                  </>
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail' &&
                  <HeroSectionWithFormAndThumbnail data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FreeFormHtml' &&
                  <FreeFormHtml data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_PlatformScrollingTicker' &&
                  <PlatformScrollingTicker data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_RelatedResources' &&
                  <RelatedResources data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_ImageGridsExecutiveTeams' &&
                  <ImageGridsExecutiveTeams data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FeaturedSection' &&
                  <FeaturedSectionModule data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_CustomerStoriesCarouselModule' &&
                  <CustomerStoryModule data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_PricingSection' &&
                  <PricingTableModule data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_ComparisonTable' &&
                  <ComparisonTableModule data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_LottieFileAnimation' &&
                  <LottieFileAnimationModule data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_MarketoFormSection' &&
                  <MarketoFormSectionModule data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_QuicksizerCalculator' &&
                  <>
                    {pwdCheck ?
                      <QuicksizerCalModule />
                      :
                      <div className="cp-passwordProtector">
                        <form id="l-passwordProtector" className="l--flex">
                          <div>
                            <label for="size">Enter password</label>
                            <input type="text" id="password" name="password" placeholder="Enter password" />
                          </div>
                          <input className="l-button" type="submit" value="Submit" />
                        </form>
                      </div>
                    }
                  </>
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_ThankYouComponent' &&
                  <ThankYouPageModule data={modularItem} />
                }
              </React.Fragment>
            ))}
          </div>
        </div>
      }
    </Layout>
  );

}

export default Page;